export const DEACTIVATE_USER = 'DEACTIVATE_USER'
